module.exports = "/_next/static/images/game-1-phone-gallery-08-27-2302-3974af5e1c6413d3c619c3e6cd1ffe5c.jpg";